import React from "react";
import { renderToString } from "react-dom/server";

import i18n from "i18n-react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  ItemCard,
  AddFavorite,
  SharingPopup,
  Image,
  WebsiteSplitter,
  LinkHandler,
} from "C4";
import { appContentUrl } from "settings";

const setIcon = (type) => {
  switch (type) {
    case "carousel":
      return "fa-images";
    case "infographic":
      return "fa-clipboard";
    case "brochure":
      return "fa-file-pdf";
    case "pdf":
      return "fa-file-pdf";
    case "web":
      return "fa-link";
    case "contact":
      return "fa-comments";
    case "layout":
      return "fa-clipboard";
    case "multi":
      return "fa-external-link-alt";
    case "directory":
      return "fa-list";
    default:
      return "";
  }
};

const parseURL = (url, type, appId) => {
  switch (type) {
    case "pdf":
      return `${appContentUrl}${appId}/${
        typeof url === "object" ? url[0] : url
      }`;
    case "image":
      return `${appContentUrl}${appId}/${
        typeof url === "object" ? url[0] : url
      }`;
    default:
      return url;
  }
};

const Slideshow = (props) => {
  const { appId, fancybox, options, urls } = props;

  const images = [];
  for (let i = 1; i < urls.length; i += 1) {
    const key = i;
    images.push(
      <div
        key={`ss_${key}`}
        href={
          urls[i].includes("http") ? urls[i] : parseURL(urls[i], "image", appId)
        }
        data-options={options}
        data-fancybox={fancybox}
        data-trigger={fancybox}
        data-type={urls[i].includes("http") && "iframe"}
        style={{ display: "none" }}
      >
        <Image
          src={parseURL(urls[i], "image", appId)}
          overrideZeroSize={100}
          alt="hidden"
        />
      </div>
    );
  }

  return images;
};

const ToolboxCard = (props) => {
  const {
    appId,
    image,
    imageName,
    subtitle,
    title,
    type,
    itemID,
    graduatedUnlockOnly,
    user,
  } = props;

  let { url } = props;

  // Catches empty content by notifying user it's coming soon.
  if (url === "") {
    url = title;
  }

  if (url.includes(",")) {
    url = url.split(",");
  }

  let shareUrl = url;
  if (Array.isArray(shareUrl)) {
    shareUrl = window.location.href;
  }

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: "x",
    },
    baseClass: "customBox",
    buttons: ["thumbs", "share", "close"],
    share: {
      tpl: renderToString(<SharingPopup url={shareUrl} image={image} title={title} />),
    },
  };

  const content = (
    <div className="textContainer">
      <ItemCard
        altImage={imageName}
        image={image}
        title={title}
        subtitle={subtitle}
        buttonText={i18n.translate("fastFacts.view")}
        buttonIcon={setIcon(type)}
      />
    </div>
  );

  if (graduatedUnlockOnly && user && !user.training_graduated) {
    return (
      <div className="toolbox__Item locked">
        <div className="textContainer">
          <ItemCard
            altImage={imageName}
            image={image}
            title={title}
            subtitle={subtitle}
            buttonText={i18n.translate("fastFacts.view")}
            buttonIcon={setIcon(type)}
          />
          <div className="unlockCopy">
            <FontAwesomeIcon icon={["fas", "lock"]} />
            <span>Complete Foundation to unlock these Exclusive Discounts</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="toolbox__Item">
      <AddFavorite appId={appId} viewType="t" upID={itemID} />
      <LinkHandler
        appId={appId}
        url={url}
        type={type}
        title={title}
        UniqueID={itemID}
        dataOptions={JSON.stringify(fancyOptions)}
        dataFancybox={itemID}
        dataTrigger={itemID}
        className="toolbox__Grid--item"
        page="t"
      >
        {/* Dummy image to fool fancybox thumbnails process */}
        {typeof url === "object" && (
          <Image src={image} alt="placeholder thumbnail" className="hidden" />
        )}
        {content}
      </LinkHandler>
      {typeof url === "object" && (
        <Slideshow
          appId={appId}
          fancybox={itemID}
          options={JSON.stringify(fancyOptions)}
          urls={url}
        />
      )}
      {type === "multi" && (
        <WebsiteSplitter itemID={itemID} appID={appId} type="toolbox" />
      )}
      {/* Empty url notification */}
      {url === "#noContent" && (
        <div id="noContent" style={{ display: "none" }}>
          <h1>{i18n.translate("errors.comingSoon")}</h1>
          <p>{i18n.translate("errors.missingContent")}</p>
        </div>
      )}
    </div>
  );
};

export default ToolboxCard;

ToolboxCard.propTypes = {
  appId: PropTypes.number.isRequired,
  image: PropTypes.string,
  imageName: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string.isRequired,
  itemID: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  graduatedUnlockOnly: PropTypes.bool,
};

ToolboxCard.defaultProps = {
  image: "",
  imageName: "",
  subtitle: "",
  title: "",
  type: "",
  graduatedUnlockOnly: false,
};
